export function normalizeRuPhone(value: string) {
  const digits = value.replace(/\D/g, '')
  if (!digits) return ''

  if (digits.startsWith('8')) {
    return `7${digits.slice(1, 11)}`
  }

  if (digits.startsWith('7')) {
    return digits.slice(0, 11)
  }

  return `7${digits.slice(0, 10)}`
}

export function formatRuPhoneInput(value: string) {
  const normalized = normalizeRuPhone(value)
  if (!normalized) return ''

  const local = normalized.slice(1)
  let result = '+7'

  if (local.length > 0) {
    result += ` (${local.slice(0, 3)}`
  }
  if (local.length >= 3) {
    result += ')'
  }
  if (local.length > 3) {
    result += ` ${local.slice(3, 6)}`
  }
  if (local.length > 6) {
    result += `-${local.slice(6, 8)}`
  }
  if (local.length > 8) {
    result += `-${local.slice(8, 10)}`
  }

  return result
}

export function isValidRuPhone(value: string) {
  return /^7\d{10}$/.test(normalizeRuPhone(value))
}
